import { Injectable } from '@angular/core';
import { HttpCacheStore } from '../../../shared/inteceptors/http-cache.store';
import { AuthService } from '../../../shared/services/auth.service';
import { BaseHttpCacheInterceptor } from '../../../shared/inteceptors/base-http-cache.interceptor';

export { CACHE_RESET_HEADER, CACHE_SKIP_HEADER } from '../../../shared/inteceptors/base-http-cache.interceptor';

@Injectable()
export class HttpCacheInterceptor extends BaseHttpCacheInterceptor {

  constructor(cacheStore: HttpCacheStore, authService: AuthService) {
    super(cacheStore, authService);
  }
}
